import React, { useState } from 'react'
import { Button, Modal, message } from "antd"
import { bulkCreateBatchShip } from '../../../services/api/apiNextBox'
import _ from "lodash"

const CreateBatchShip = (props) => {
    const {
        reload,
        isOpen,
        onCancel,
        selectedItems,
        setSelectedItems,
    } = props

    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')

    const _onSubmit = async () => {
        try {
            setLoading(true)
            const payload = {
                box_ids: selectedItems.map(i => i._id)
            }
            const { data: response } = await bulkCreateBatchShip(payload)

            const { data = [], success, message: err } = response
            if (!success) throw new Error(err)

            if (Array.isArray(data) && data.length > 0 && !!_.get(data[0], 'error')) {
                return setError(data)
            }

            message.success("Tạo lô ship thành công.")
            //Open batch-ship details in new tab
            const listBatchShipIds = (data || []).map(i => !!i.batch && i.batch._id).filter(Boolean)
            listBatchShipIds.forEach(i => {
                window.open(`/batch-ship/${i}`, '_blank', 'noopener,noreferrer')
            })
            onCancel('isCreateBatchShip')
            reload()
            setSelectedItems()
        } catch (error) {
            setError(error.message)
        } finally {
            setLoading(false)
        }
    }

    const handleCancel = () => {
        onCancel('isCreateBatchShip')
        setSelectedItems()
        setError('')
    }

    return (
        <Modal
            className="CreateBatchShip"
            visible={isOpen}
            title="Tạo lô ship"
            width={800}
            onCancel={handleCancel}
            footer={[
                <Button key="back" disabled={loading} onClick={handleCancel}>
                    Cancel
                </Button>,
                <Button
                    key="submit"
                    type="primary"
                    loading={loading}
                    onClick={_onSubmit}
                    disabled={Array.isArray(error) ? !!error.length : !!error}
                >
                    Tạo lô ship
                </Button>
            ]}
        >
            <h3>Tạo lô ship cho các thùng: <span className='font-weight-bold'>{selectedItems.map(i => `#${i.id}`).join(", ")}</span></h3>
            {
                (Array.isArray(error) && !!error.length) ? (
                    <ul style={{ listStyle: 'none' }} className='p-0'>
                        {
                            error.map((err, i) => (
                                <li key={i} className='text-danger font-weight-bold'>{err.error}</li>
                            ))
                        }
                    </ul>
                ) : (
                    !!error && <span className='mt-2 text-danger font-weight-bold'>{error}</span>
                )
            }
        </Modal>
    )
}

export default CreateBatchShip
